var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"container-xxl full-loader"},[_c('div',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":`${_vm.baseUrl}flexigo-loader.gif`}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }